import { isLearnTest } from "./utils";

// Disable console methods in production
export function disableConsoleInProduction() {
  if (typeof window === 'undefined') return;
  
  // Check if we're in production mode
  // In Next.js, this will be replaced at build time
  if (process.env.NODE_ENV === 'production' && !isLearnTest) {
    const noop = () => {};
    const consoleMethods = [
      'log', 'debug', 'info', 'warn', 'error', 'assert', 'clear', 'count',
      'countReset', 'dir', 'dirxml', 'group', 'groupCollapsed', 'groupEnd',
      'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeLog',
      'timeStamp', 'trace'
    ] as const;
    
    consoleMethods.forEach((method) => {
      if (method in console) {
        (console as any)[method] = noop;
      }
    });
  }
}